/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/analytics/export": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export banking data for analytics
     * @description Exports connections, accounts, mandates, and soft-deleted transactions data from all customers for analytics purposes. Data excludes providerData fields and converts timestamps to ISO 8601 format. Processes customers in parallel batches and continues on individual failures.
     */
    get: operations["getApiAnalyticsExport"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all customers with activated mandates
     * @description Retrieves a paginated list of all customers that have at least one mandate in activated state.
     */
    get: operations["getApiCustomers"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/accounts": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get accounts ids for a specific customer
     * @description Retrieves a list of account ids for a given customer ID.
     */
    get: operations["getApiCustomersByCustomerIdAccounts"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/accounts/{accountId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get accounts details for a specific account
     * @description Retrieves details for a given account ID.
     */
    get: operations["getApiCustomersByCustomerIdAccountsByAccountId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/accounts/{accountId}/label": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set or clear a bank-account label
     * @description Sets, changes, or clears the Tax Ops label for a bank account. The label is nullable and the only supported value is expected_low_activity.
     */
    patch: operations["patchApiCustomersByCustomerIdAccountsByAccountIdLabel"];
    trace?: never;
  };
  "/api/customers/{customerId}/accounts/{accountId}/pause": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Pause bank sync for a single account
     * @description Pauses sync for a specific account by setting its pausedAt timestamp and re-running the workflow schedule setup so the account stops feeding scheduled sync workflows. Already-synced transactions and the account itself remain visible everywhere else. Idempotent: pausing an already-paused account is a no-op.
     */
    post: operations["postApiCustomersByCustomerIdAccountsByAccountIdPause"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/accounts/{accountId}/reconcile": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Trigger reconciliation for a single account
     * @description Enqueues a reconciliation workflow for a specific account. Regular mode reconciles the last 30 days. Historical mode reconciles from the specified start date (or connection historical start date) to present.
     */
    post: operations["postApiCustomersByCustomerIdAccountsByAccountIdReconcile"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/accounts/{accountId}/resume": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resume bank sync for a single account
     * @description Resumes sync for a previously paused account by clearing its pausedAt timestamp and re-running the workflow schedule setup so the account feeds scheduled sync workflows again. Idempotent: resuming an account that is not paused is a no-op.
     */
    post: operations["postApiCustomersByCustomerIdAccountsByAccountIdResume"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get connection ids for a specific customer
     * @description Retrieves a list of connection ids for a given customer ID.
     */
    get: operations["getApiCustomersByCustomerIdConnections"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/connections/{connectionId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get connection details for a specific connection
     * @description Retrieves details for a given connection ID.
     */
    get: operations["getApiCustomersByCustomerIdConnectionsByConnectionId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/connections/{connectionId}/archive": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive a connection
     * @description Archives a connection by marking it as inactive, deleting the associated mandate from both the Mandates KV store and GoCardless, canceling all scheduled sync workflows, and archiving all related accounts. Historical transaction data is preserved. This operation is asynchronous and returns a workflow ID to track progress.
     */
    post: operations["postApiCustomersByCustomerIdConnectionsByConnectionIdArchive"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/dump": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Dump the state of the customer
     * @description Retrieves the current state of the customer for debugging purposes.
     */
    get: operations["getApiCustomersByCustomerIdDump"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/enqueue-workflow": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Enqueue transactions sync workflow for customer
     * @description Enqueues a transactions sync workflow for all active accounts of a given customer ID. This endpoint creates workflow instances that will synchronize transaction data for each active account.
     */
    get: operations["getApiCustomersByCustomerIdEnqueue-workflow"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/setup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup workflow schedules for customer
     * @description Initializes or resets workflow schedules for a customer. This creates recurring schedules for account details sync, transactions sync, and account balances sync based on the customer's active accounts. Use this endpoint to recover from scheduling issues or to initialize schedules for new customers.
     */
    post: operations["postApiCustomersByCustomerIdSetup-schedule"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/transactions": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get transactions for a specific customer
     * @description Retrieves a paginated list of transactions for a given customer ID with optional date range filtering. When no date filters are provided, returns all transactions including those with null dates. When any date filter (fromDate or toDate) is specified, only transactions with valid dates are included, excluding null-date transactions.
     */
    get: operations["getApiCustomersByCustomerIdTransactions"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/transactions/count": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get transaction count for a specific customer
     * @description Retrieves the total count of transactions for a given customer ID with optional date range filtering. When no date filters are provided, returns count of all transactions. When date filters are specified, only transactions with valid dates are counted.
     */
    get: operations["getApiCustomersByCustomerIdTransactionsCount"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/transactions/restore": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Restore soft-deleted transactions
     * @description Restores transactions that were incorrectly soft-deleted by clearing their deleted_at timestamp. Accepts an array of transaction IDs to restore.
     */
    post: operations["postApiCustomersByCustomerIdTransactionsRestore"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/institutions": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Banking Institutions
     * @description Retrieves the list of institutions for one country. Defaults to Germany (DE); pass `country` to list the banks of another supported country, e.g. FI for Holvi.
     */
    get: operations["getApiInstitutions"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/institutions/{institutionId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Banking Institution Details
     * @description Retrieves details of a specific institution by ID
     */
    get: operations["getApiInstitutionsByInstitutionId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/mandates": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Mandates
     * @description Retrieves a list of all mandates.
     */
    get: operations["getApiMandates"];
    put?: never;
    /**
     * Create Mandate Consent
     * @description Creates a mandate consent workflow for a customer.
     */
    post: operations["postApiMandates"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/mandates/{customerId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Mandates for a customer
     * @description Retrieves a list of mandates for a specific customer.
     */
    get: operations["getApiMandatesByCustomerId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/mandates/{customerId}/{institutionId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Mandate
     * @description Deletes a mandate for a customer. Only works for mandates in errored, timeout, pending, or renewal states. Other states require different handling.
     */
    delete: operations["deleteApiMandatesByCustomerIdByInstitutionId"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/migration/enqueue-transaction-migrations": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Enqueue transaction migration workflows for customers
     * @description Manually triggers transaction migration workflows. Can target specific customers or all activated customers. Supports dry-run mode to preview changes without enqueuing workflows.
     */
    post: operations["postApiMigrationEnqueue-transaction-migrations"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    Account: {
      accountNumber: string | null;
      archivedAt: string | null;
      connectionId: string;
      createdAt: string;
      currency: string | null;
      details: string | null;
      iban: string | null;
      id: string;
      /** @enum {string|null} */
      label: "expected_low_activity" | null;
      lastSyncedAt: string;
      lastTransactionsAddedAt: string | null;
      name: string | null;
      ownerName: string | null;
      pausedAt: string | null;
      product: string | null;
      updatedAt: string;
    };
    AccountDetails: {
      /** @description The latest balance amount */
      latestBalanceAmount: number;
      /** @description The latest balance currency */
      latestBalanceCurrency: string;
    } & components["schemas"]["Account"];
    /** @description Details of an HTTP 400 error. */
    ApiErrorDetails400: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Bad Request
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 400
       * @constant
       */
      statusCode: 400;
    };
    /** @description Details of an HTTP 401 error. */
    ApiErrorDetails401: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Unauthorized
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 401
       * @constant
       */
      statusCode: 401;
    };
    /** @description Details of an HTTP 404 error. */
    ApiErrorDetails404: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Not Found
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 404
       * @constant
       */
      statusCode: 404;
    };
    /** @description Details of an HTTP 409 error. */
    ApiErrorDetails409: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Conflict
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 409
       * @constant
       */
      statusCode: 409;
    };
    /** @description Details of an HTTP 500 error. */
    ApiErrorDetails500: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example InternalServerError
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Internal Server Error
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 500
       * @constant
       */
      statusCode: 500;
    };
    Connection: {
      accessValidUntil: string | null;
      agreementAcceptedAt: string | null;
      archivedAt: string | null;
      createdAt: string;
      customerId: string;
      expiredAt: string | null;
      historicalStartDate: string | null;
      id: string;
      institutionId: string;
      maxHistoricalDays: number;
      updatedAt: string;
    };
    CreateMandateParams: {
      accessScope: ("balances" | "details" | "transactions")[];
      accessValidForDays: number;
      accountSelection: boolean;
      customerDisplayName: string;
      customerEmail: string;
      /** Format: uuid */
      customerId: string;
      customerLanguage: string;
      historicalStartDate: string;
      institutionId: string;
      maxHistoricalDays: number;
    };
    Customer: {
      /** @description Unique identifier for the customer */
      customerId: string;
    };
    DeleteMandateParams: {
      /** Format: uuid */
      customerId: string;
      institutionId: string;
    };
    DumpData: {
      /** @description Durable Object storage information */
      storage: components["schemas"]["DumpStorageInfo"];
      tables: components["schemas"]["DumpTableInfo"][];
    };
    DumpStorageInfo: {
      /** @description ISO 8601 timestamp of next scheduled alarm, or null if no alarm set */
      nextAlarm: string | null;
      /** @description Current workflow schedules stored in Durable Object */
      workflowSchedule: components["schemas"]["WorkflowScheduleInfo"][] | null;
    };
    DumpTableInfo: {
      data: unknown[];
      name: string;
      schema: string;
    };
    ErrorResponse400: {
      error: components["schemas"]["ApiErrorDetails400"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse401: {
      error: components["schemas"]["ApiErrorDetails401"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse404: {
      error: components["schemas"]["ApiErrorDetails404"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse409: {
      error: components["schemas"]["ApiErrorDetails409"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse500: {
      error: components["schemas"]["ApiErrorDetails500"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    Institution: {
      bic?: string;
      id: string;
      logo: string;
      max_access_valid_for_days: number;
      name: string;
      transaction_total_days: number;
    };
    InstitutionDetails: {
      supported_features: string[];
    } & components["schemas"]["Institution"];
    Mandate: {
      /** @description The ID of the connection created after mandate activation */
      connectionId?: string;
      /** @description The timestamp when the mandate was created */
      createdAt: string;
      /** @description The ID of the customer who owns the mandate */
      customerId: string;
      /** @description The ID of the financial institution associated with the mandate */
      institutionId: string;
      /** @description The reference of the mandate */
      reference: string;
      /**
       * @description The current state of the mandate
       * @enum {string}
       */
      state:
        | "errored"
        | "pending"
        | "accepted"
        | "processing"
        | "activated"
        | "timeout"
        | "renewal";
      /** @description The timestamp when the mandate was last updated */
      updatedAt: string;
    };
    /** @description Standard pagination information */
    PaginationInfo: {
      /**
       * @description Maximum number of items returned per page
       * @example 10
       */
      limit: number;
      /**
       * @description Number of items skipped from the beginning
       * @example 0
       */
      offset: number;
      /**
       * @description Total number of items available
       * @example 100
       */
      total: number;
    };
    Transaction: {
      accountId: string;
      amount: number;
      bookingDate: string | null;
      counterpartyIban: string | null;
      counterpartyName: string | null;
      createdAt: string;
      currency: string;
      description: string | null;
      direction: string | null;
      id: string;
      valueDate: string | null;
    };
    WorkflowScheduleInfo: {
      /** @description Interval between executions in milliseconds */
      intervalMs: number;
      /** @description Unix timestamp of last execution */
      lastExecutionTime?: number;
      /** @description Unix timestamp of next execution */
      nextExecutionTime: number;
      options: {
        params: {
          /** @description Account ID */
          accountId: string;
          /** @description Customer UUID */
          customerId: string;
        };
      }[];
      /** @description Schedule status (active, paused, failed) */
      status: string;
      /** @description Workflow type (e.g., transactionsSync, accountDetailsSync) */
      type: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type Account = components["schemas"]["Account"];
export type AccountDetails = components["schemas"]["AccountDetails"];
export type ApiErrorDetails400 = components["schemas"]["ApiErrorDetails400"];
export type ApiErrorDetails401 = components["schemas"]["ApiErrorDetails401"];
export type ApiErrorDetails404 = components["schemas"]["ApiErrorDetails404"];
export type ApiErrorDetails409 = components["schemas"]["ApiErrorDetails409"];
export type ApiErrorDetails500 = components["schemas"]["ApiErrorDetails500"];
export type Connection = components["schemas"]["Connection"];
export type CreateMandateParams = components["schemas"]["CreateMandateParams"];
export type Customer = components["schemas"]["Customer"];
export type DeleteMandateParams = components["schemas"]["DeleteMandateParams"];
export type DumpData = components["schemas"]["DumpData"];
export type DumpStorageInfo = components["schemas"]["DumpStorageInfo"];
export type DumpTableInfo = components["schemas"]["DumpTableInfo"];
export type ErrorResponse400 = components["schemas"]["ErrorResponse400"];
export type ErrorResponse401 = components["schemas"]["ErrorResponse401"];
export type ErrorResponse404 = components["schemas"]["ErrorResponse404"];
export type ErrorResponse409 = components["schemas"]["ErrorResponse409"];
export type ErrorResponse500 = components["schemas"]["ErrorResponse500"];
export type Institution = components["schemas"]["Institution"];
export type InstitutionDetails = components["schemas"]["InstitutionDetails"];
export type Mandate = components["schemas"]["Mandate"];
export type PaginationInfo = components["schemas"]["PaginationInfo"];
export type Transaction = components["schemas"]["Transaction"];
export type WorkflowScheduleInfo =
  components["schemas"]["WorkflowScheduleInfo"];
export type $defs = Record<string, never>;
export interface operations {
  getApiAnalyticsExport: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully exported analytics data. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data:
              | {
                  customerCount: number;
                  failedCount: number;
                  records: {
                    accounts: {
                      accountNumber: string;
                      archivedAt: string;
                      connectionId: string;
                      createdAt: string;
                      currency: string;
                      customerId: string;
                      details: string;
                      iban: string;
                      id: string;
                      /** @enum {string|null} */
                      label: "expected_low_activity" | null;
                      lastSyncedAt: string;
                      lastTransactionsAddedAt: string | null;
                      name: string;
                      ownerName: string;
                      pausedAt: string;
                      product: string;
                      providerAccountId: string;
                      updatedAt: string;
                    }[];
                    connections: {
                      accessValidUntil: string;
                      agreementAcceptedAt: string;
                      archivedAt: string;
                      createdAt: string;
                      customerId: string;
                      historicalStartDate: string;
                      id: string;
                      institutionId: string;
                      maxHistoricalDays: number;
                      provider: string;
                      updatedAt: string;
                    }[];
                    mandates: {
                      connectionId: string;
                      consentLink: string;
                      createdAt: string;
                      customerId: string;
                      error: string;
                      institutionId: string;
                      state: string;
                      updatedAt: string;
                    }[];
                    softDeletedTransactions: {
                      accountIban: string;
                      accountId: string;
                      accountName: string;
                      amount: number;
                      bookingDate: string;
                      counterpartyIban: string;
                      counterpartyName: string;
                      createdAt: string;
                      currency: string;
                      customerId: string;
                      deletedAt: string;
                      description: string;
                      direction: string;
                      institutionId: string;
                      providerTransactionId: string;
                      transactionId: string;
                      updatedAt: string;
                      valueDate: string;
                    }[];
                  };
                }
              | {
                  accountIban: string;
                  accountId: string;
                  accountName: string;
                  amount: number;
                  bookingDate: string;
                  counterpartyIban: string;
                  counterpartyName: string;
                  createdAt: string;
                  currency: string;
                  customerId: string;
                  deletedAt: string;
                  description: string;
                  direction: string;
                  institutionId: string;
                  providerTransactionId: string;
                  transactionId: string;
                  updatedAt: string;
                  valueDate: string;
                }[];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomers: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of customers with activated mandates. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Customer"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdAccounts: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved a list of account ids. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Account"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdAccountsByAccountId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        accountId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved account details. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["AccountDetails"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  patchApiCustomersByCustomerIdAccountsByAccountIdLabel: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        accountId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": {
          /** @enum {string|null} */
          label: "expected_low_activity" | null;
        };
      };
    };
    responses: {
      /** @description Account label updated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Account ID */
              accountId: string;
              /**
               * @description The account label, or null when the label is cleared
               * @enum {string|null}
               */
              label: "expected_low_activity" | null;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Account not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdAccountsByAccountIdPause: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        accountId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Account paused successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Account ID */
              accountId: string;
              /** @description ISO 8601 timestamp when the account was paused */
              pausedAt: string | null;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Account not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdAccountsByAccountIdReconcile: {
    parameters: {
      query?: {
        fromDate?: string;
        mode?: "regular" | "historical";
      };
      header?: never;
      path: {
        accountId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Reconciliation workflow started successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Account ID */
              accountId: string;
              /** @description Customer ID */
              customerId: string;
              /**
               * @description Reconciliation mode
               * @enum {string}
               */
              mode: "regular" | "historical";
              /**
               * @description Workflow status
               * @constant
               */
              status: "started";
              /** @description ID of the enqueued workflow */
              workflowId: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid parameters */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Failed to start reconciliation workflow */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdAccountsByAccountIdResume: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        accountId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Account resumed successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Account ID */
              accountId: string;
              /** @description Always null - the account is no longer paused */
              pausedAt: string | null;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Account not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdConnections: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved a list of connection ids. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdConnectionsByConnectionId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connectionId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved connection details. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdConnectionsByConnectionIdArchive: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connectionId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully started connection archival workflow. Use the workflow ID to track progress. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Connection ID being archived */
              connectionId: string;
              /** @description Customer ID who owns the connection */
              customerId: string;
              /**
               * @description Workflow status - always "started" on success
               * @constant
               */
              status: "started";
              /** @description Unique identifier for the archival workflow */
              workflowId: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDump: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the customer state. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["DumpData"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdEnqueue-workflow": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued workflow instances for all active accounts. Returns detailed information about the created workflows. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "postApiCustomersByCustomerIdSetup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully set up workflow schedules. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Detailed message about the operation result */
              message: string;
              /**
               * @description Status of the setup operation
               * @constant
               */
              status: "completed";
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdTransactions: {
    parameters: {
      query?: {
        accountId?: string;
        cursor?: string;
        fromDate?: string;
        limit?: number;
        needsMigration?: boolean;
        offset?: number;
        sortBy?: "bookingDate" | "valueDate" | "createdAt";
        sortOrder?: "asc" | "desc";
        toDate?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved a paginated list of transactions. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Transaction"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdTransactionsCount: {
    parameters: {
      query?: {
        fromDate?: string;
        toDate?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved transaction count. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Total number of transactions matching the criteria */
              count: number;
              /** @description Customer ID */
              customerId: string;
              /** @description Start date filter (YYYY-MM-DD) or null */
              fromDate: string | null;
              /** @description End date filter (YYYY-MM-DD) or null */
              toDate: string | null;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiCustomersByCustomerIdTransactionsRestore: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": {
          /** @description Transaction IDs to restore */
          transactionIds: string[];
        };
      };
    };
    responses: {
      /** @description Transactions restored successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of transactions restored */
              restoredCount: number;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiInstitutions: {
    parameters: {
      query?: {
        /**
         * @description Two-letter uppercase country code (ISO 3166-1 alpha-2) of the banks to list. Defaults to DE.
         * @default DE
         */
        country?:
          | "AT"
          | "BE"
          | "BG"
          | "HR"
          | "CY"
          | "CZ"
          | "DK"
          | "EE"
          | "FI"
          | "FR"
          | "DE"
          | "GR"
          | "HU"
          | "IS"
          | "IE"
          | "IT"
          | "LV"
          | "LI"
          | "LT"
          | "LU"
          | "MT"
          | "NL"
          | "NO"
          | "PL"
          | "PT"
          | "RO"
          | "SK"
          | "SI"
          | "ES"
          | "SE"
          | "GB";
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of institutions for the country */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Institution"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiInstitutionsByInstitutionId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        institutionId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved details of a specific institution */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["InstitutionDetails"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiMandates: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of mandates. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Mandate"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiMandates: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["CreateMandateParams"];
      };
    };
    responses: {
      /** @description Successfully enqueued the mandate consent workflow. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              status: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiMandatesByCustomerId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of mandates for the customer. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Mandate"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  deleteApiMandatesByCustomerIdByInstitutionId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        institutionId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully deleted the mandate. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              deleted: boolean;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Mandate not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Mandate cannot be deleted in its current state. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse409"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "postApiMigrationEnqueue-transaction-migrations": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Migration workflows enqueued successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Whether this was a dry run */
              dryRun: boolean;
              /** @description Number of customers with workflows enqueued */
              enqueuedCustomers: number;
              /** @description Customer IDs that were found and eligible for migration */
              foundCustomers: string[];
              /** @description Specific customer IDs that were targeted (if any) */
              targetedCustomers?: string[];
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Failed to enqueue migration workflows */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
}
export enum ApiPaths {
  postApiMandates = "/api/mandates",
  getApiMandates = "/api/mandates",
  getApiMandatesByCustomerId = "/api/mandates/{customerId}",
  deleteApiMandatesByCustomerIdByInstitutionId = "/api/mandates/{customerId}/{institutionId}",
  getApiInstitutions = "/api/institutions",
  getApiInstitutionsByInstitutionId = "/api/institutions/{institutionId}",
  getApiCustomers = "/api/customers",
  getApiCustomersByCustomerIdConnections = "/api/customers/{customerId}/connections",
  getApiCustomersByCustomerIdConnectionsByConnectionId = "/api/customers/{customerId}/connections/{connectionId}",
  postApiCustomersByCustomerIdConnectionsByConnectionIdArchive = "/api/customers/{customerId}/connections/{connectionId}/archive",
  getApiCustomersByCustomerIdAccounts = "/api/customers/{customerId}/accounts",
  getApiCustomersByCustomerIdAccountsByAccountId = "/api/customers/{customerId}/accounts/{accountId}",
  patchApiCustomersByCustomerIdAccountsByAccountIdLabel = "/api/customers/{customerId}/accounts/{accountId}/label",
  postApiCustomersByCustomerIdAccountsByAccountIdReconcile = "/api/customers/{customerId}/accounts/{accountId}/reconcile",
  postApiCustomersByCustomerIdAccountsByAccountIdPause = "/api/customers/{customerId}/accounts/{accountId}/pause",
  postApiCustomersByCustomerIdAccountsByAccountIdResume = "/api/customers/{customerId}/accounts/{accountId}/resume",
  postApiCustomersByCustomerIdTransactionsRestore = "/api/customers/{customerId}/transactions/restore",
  getApiCustomersByCustomerIdTransactionsCount = "/api/customers/{customerId}/transactions/count",
  getApiCustomersByCustomerIdTransactions = "/api/customers/{customerId}/transactions",
  getApiCustomersByCustomerIdEnqueue_workflow = "/api/customers/{customerId}/enqueue-workflow",
  getApiCustomersByCustomerIdDump = "/api/customers/{customerId}/dump",
  postApiCustomersByCustomerIdSetup_schedule = "/api/customers/{customerId}/setup-schedule",
  postApiMigrationEnqueue_transaction_migrations = "/api/migration/enqueue-transaction-migrations",
  getApiAnalyticsExport = "/api/analytics/export",
}
